export class CertificatDouane {


    id_certificat_douane: number;
    idClient: number;

    date_envoie: Date;

    voie: String;
    entreprise: String;
}